@if (show) {
  <div>
    <div class="app-loader">
      <img style="width:30px" src="/assets/imgs/loader.gif" alt="">
    </div>
  </div>
}